import { createContext } from "react";
import type { User } from "firebase/auth";
import type { UserProfile } from "../types";

export interface AuthState {
  user: User | null;
  profile: UserProfile | null;
  isAdmin: boolean;
  isOwner: boolean;
  loading: boolean;
}

export const AuthContext = createContext<AuthState>({
  user: null,
  profile: null,
  isAdmin: false,
  isOwner: false,
  loading: true,
});
